<template>
    <edit-dialog title="Thema kleuren kiezer" :event="save">

        <template v-slot:button="{ on, attrs }">
            <!--im designed for the header profile dropdown menu :D-->
            <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-action>
                    <v-icon>mdi-shape-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Thema kleuren</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>

        <v-btn color="error" @click="deleteTheme"><v-icon left>mdi-delete</v-icon>Verwijder alle aanpassingen</v-btn>


        <div v-for="(colortheme,themeName) of theme.themes" :key="themeName">
            <v-divider class="my-5"/>
            <h1>{{ themeName }} thema</h1>

            <v-row>
                <v-col md="4" v-for="(color,colorType) of colortheme" :key="themeName+'-'+colorType">
                    <strong>{{ colorType }}</strong>
                    <v-color-picker
                        :value="color"
                        @update:color="updateColor(themeName,colorType,$event)"
                        dot-size="25"
                        mode="hexa"
                    ></v-color-picker>
                </v-col>
            </v-row>
        </div>

    </edit-dialog>
</template>

<script>
import clone from "lodash/clone";
import CookieService from "@/utils/Services/CookieService";
import EditDialog from "@/components/General/Dialog/EditDialog";

export default {
    name: "ThemeColorPicker",
    components: {EditDialog},
    data() {
        return {
            theme: this.$vuetify.theme,
            editTheme: {},
        }
    },
    watch: {
        editTheme: {
            handler() {
                this.setColors();
            },
            deep: true
        }
    },
    methods: {
        updateColor(themeName, colorType, $event) {
            this.editTheme[themeName][colorType] = $event.hex;
        },
        setColors() {
            Object.keys(this.editTheme.dark).forEach(i => {
                this.$vuetify.theme.themes.dark[i] = this.editTheme.dark[i];
            });
            Object.keys(this.editTheme.light).forEach(i => {
                this.$vuetify.theme.themes.light[i] = this.editTheme.light[i];
            });
        },
        save() {
            CookieService.set('theme', 'dark', this.editTheme.dark, -1);
            CookieService.set('theme', 'light', this.editTheme.light, -1);
            return Promise.resolve();
        },
        deleteTheme(){
            CookieService.remove('theme');
            this.editTheme = this.$vuetify.theme.defaults;

        }
    },
    created() {
        if (CookieService.get('theme').light) {
            this.editTheme = CookieService.get('theme');
            this.setColors();
        } else {
            this.editTheme = clone(this.$vuetify.theme.themes);
        }
    },

}
</script>

